import './CGU.css';

const ARTICLES = [
  {
    num: 1,
    title: 'Société',
    content: (
      <p>
        Le site <strong>www.globalsourcingsolutiongroup.com</strong> est édité par <strong>Global Sourcing Solution Group (GSSG)</strong>, Société par Actions Simplifiée, dont le siège social est situé au 52 avenue de la République, 78500 Sartrouville.
      </p>
    ),
  },
  {
    num: 2,
    title: 'Objet des présentes CGU',
    content: (
      <>
        <p>
          Les présentes CGU ont pour objet de définir les modalités d'accès et d'utilisation du site <strong>www.globalsourcingsolutiongroup.com</strong> ainsi que des services proposés par Global Sourcing Solution Group.
        </p>
        <p>En naviguant sur le site, l'utilisateur accepte pleinement et sans réserve les présentes CGU.</p>
      </>
    ),
  },
  {
    num: 3,
    title: 'Accès au site et aux services',
    content: (
      <>
        <p>
          Le site est accessible à tout utilisateur disposant d'un accès à Internet. Certains services peuvent nécessiter la création d'un compte ou la transmission d'informations professionnelles.
        </p>
        <p>
          L'utilisateur s'engage à fournir des informations exactes, complètes et à jour lors de l'utilisation des formulaires de contact ou de création de compte.
        </p>
        <p>
          Global Sourcing Solution Group se réserve le droit de suspendre ou limiter l'accès à certains services en cas d'utilisation frauduleuse, abusive ou non conforme aux présentes CGU.
        </p>
      </>
    ),
  },
  {
    num: 4,
    title: 'Compte utilisateur',
    content: (
      <>
        <p>
          Lorsque la création d'un compte est nécessaire, l'utilisateur est responsable de la confidentialité de ses identifiants et mot de passe.
        </p>
        <p>
          Le compte est strictement personnel et ne peut être cédé, prêté ou partagé avec un tiers. Toute activité réalisée depuis le compte de l'utilisateur est réputée avoir été effectuée par celui-ci.
        </p>
        <p>
          En cas de suspicion d'utilisation frauduleuse ou de perte des identifiants, l'utilisateur doit informer Global Sourcing Solution Group dans les meilleurs délais.
        </p>
      </>
    ),
  },
  {
    num: 5,
    title: 'Services proposés',
    content: (
      <>
        <p>Global Sourcing Solution Group propose notamment des services de :</p>
        <ul>
          <li>sourcing et approvisionnement en Chine ;</li>
          <li>accompagnement logistique et supply chain ;</li>
          <li>conseil en immobilier ;</li>
          <li>conseil et accompagnement informatique.</li>
        </ul>
        <p>
          Les informations présentées sur le site sont fournies à titre indicatif et peuvent être modifiées à tout moment sans préavis.
        </p>
      </>
    ),
  },
  {
    num: 6,
    title: 'Propriété intellectuelle',
    content: (
      <>
        <p>
          L'ensemble du contenu présent sur le site (textes, images, logos, graphismes, vidéos, documents, éléments visuels et techniques) est protégé par les lois relatives à la propriété intellectuelle.
        </p>
        <p>
          Toute reproduction, diffusion, modification ou exploitation, totale ou partielle, du contenu du site sans autorisation écrite préalable de Global Sourcing Solution Group est strictement interdite.
        </p>
      </>
    ),
  },
  {
    num: 7,
    title: 'Responsabilité',
    content: (
      <>
        <p>
          Global Sourcing Solution Group met en œuvre tous les moyens raisonnables afin d'assurer l'exactitude des informations et la disponibilité du site.
        </p>
        <p>Toutefois, la société ne saurait être tenue responsable :</p>
        <ul>
          <li>d'une interruption temporaire du site ;</li>
          <li>d'erreurs ou omissions dans les contenus ;</li>
          <li>de dommages résultant de l'utilisation du site ou d'un accès non autorisé ;</li>
          <li>de problèmes techniques liés au réseau Internet ou aux équipements de l'utilisateur.</li>
        </ul>
        <p>L'utilisateur reste seul responsable de l'utilisation qu'il fait des informations et services disponibles sur le site.</p>
      </>
    ),
  },
  {
    num: 8,
    title: 'Données personnelles',
    content: (
      <>
        <p>
          Les données collectées via le site sont utilisées uniquement dans le cadre des services proposés par Global Sourcing Solution Group.
        </p>
        <p>
          Les informations personnelles sont traitées conformément à la réglementation en vigueur relative à la protection des données personnelles.
        </p>
        <p>
          L'utilisateur peut exercer ses droits d'accès, de rectification ou de suppression de ses données en contactant Global Sourcing Solution Group via le formulaire de contact du site.
        </p>
      </>
    ),
  },
  {
    num: 9,
    title: 'Liens externes',
    content: (
      <p>
        Le site peut contenir des liens vers des sites tiers. Global Sourcing Solution Group ne peut être tenu responsable du contenu ou du fonctionnement de ces sites externes.
      </p>
    ),
  },
  {
    num: 10,
    title: 'Modification des CGU',
    content: (
      <>
        <p>
          Global Sourcing Solution Group se réserve le droit de modifier les présentes CGU à tout moment.
        </p>
        <p>Les nouvelles conditions entreront en vigueur dès leur publication sur le site.</p>
      </>
    ),
  },
  {
    num: 11,
    title: 'Droit applicable',
    content: (
      <>
        <p>Les présentes CGU sont soumises au droit français.</p>
        <p>
          En cas de litige relatif à l'utilisation du site, les parties rechercheront une solution amiable avant toute action judiciaire. À défaut, les tribunaux compétents français seront seuls compétents.
        </p>
      </>
    ),
  },
];

export default function CGU() {
  return (
    <div className="cgu-page">
      <div className="cgu-hero">
        <div className="cgu-hero__inner">
          <span className="cgu-hero__tag">Mentions légales</span>
          <h1 className="cgu-hero__title">CGU</h1>
          <p className="cgu-hero__meta">
            <span translate="no">Global Sourcing Solution Group</span> — 52 avenue de la République, 78500 Sartrouville
          </p>
        </div>
      </div>

      <div className="cgu-body">
        <div className="cgu-body__inner" translate="no">
          {ARTICLES.map(article => (
            <article key={article.num} className="cgu-article">
              <h2 className="cgu-article__title">
                <span className="cgu-article__num">Article {article.num}</span>
                {article.title}
              </h2>
              <div className="cgu-article__content">{article.content}</div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}
